import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

/**
 * Хук вызова timeout
 * @param func - функция
 * @param time - время вызова в мс
 * @param defaultToggle - должен ли таймаут быть включённым изначально
 * @param loop - цикличность вызовов
 * @param fresh - нужно ли обновлять функцию в таймауте
 * @returns [toggleTimeout] - переключение состояния таймаута (вкл/выкл)
 */
export const useExecuteTimeout = (
  func: () => void,
  time: number,
  defaultToggle = false,
  loop = false,
  fresh = false
): [Dispatch<SetStateAction<boolean>>] => {
  const [isTimeoutOn, setIsTimeoutOn] = useState<boolean>(defaultToggle)
  const timeout = useRef<NodeJS.Timeout>()
  const funRef = useRef(func)

  useEffect(() => {
    if (fresh) {
      funRef.current = func
    }
  }, [func])

  useEffect(() => {
    if (time && isTimeoutOn) {
      const startTimeout = () => {
        funRef.current()
        if (loop) {
          timeout.current = setTimeout(startTimeout, time)
        }
      }

      timeout.current = setTimeout(startTimeout, time)
    }

    return stopTimeout
  }, [isTimeoutOn, time])

  const stopTimeout = () => {
    clearTimeout(timeout.current)
  }

  return [setIsTimeoutOn]
}
